module.exports = __webpack_public_path__ + "static/media/tickets-icon.5bf9417d.svg";